import React from "react";
import "../../assets/css/style.css";

function Tamasbama() {
  return (
    <div className="mohtava-mine">
      <div className="dive-about-done">
        <h2 className="gift-stap-p-1">تماس با دان</h2>

        <p className="text-center">
          ما همواره از شنیدن انتقادات و پیشنهادات شما خوشحال می‌شویم و از آن‌ها برای بهبود هرچه بیشتر نرم‌افزار بهره می‌گیریم. در هر زمان پذیرای تماس و نظرات ارزشمند شما هستیم.
        </p>

        <a href="tel:02188233847" className="loginbtn-1 dokme-tamas-done" role="button">
          02188233847
        </a>
      </div>
    </div>
  );
}

export default Tamasbama;
